// extracted by mini-css-extract-plugin
export default {"homeBtn":"HomeBtn_homeBtn__wXypY","btnstyle":"HomeBtn_btnstyle__qwyxl"};